module.exports = __webpack_public_path__ + "media/images/webpage/hotels/539/floorguide/course-3-photo-7-a4c48f2f015ffcfab4ce6071e0350280.webp";